<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Create User </h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Name *</label>
                  <div class="col-md-10">
                    <input
                      id="name"
                      v-model="entity.name"
                      type="text"
                      placeholder="Enter name"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="title" class="col-md-2">Email *</label>
                  <div class="col-md-10">
                    <input
                      id="email"
                      v-model="entity.email"
                      type="text"
                      placeholder="Enter email"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="title" class="col-md-2">Password *</label>
                  <div class="col-md-10">
                    <input
                      id="password"
                      v-model="entity.password"
                      type="password"
                      placeholder="Enter password"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="title" class="col-md-2">Password Confirmation *</label>
                  <div class="col-md-10">
                    <input
                      id="password_confirmation"
                      v-model="entity.password_confirmation"
                      type="password"
                      placeholder="Enter password"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Roles</label>
                  <div class="col-md-10">
                    <vue-select
                      v-model="entity.roles"
                      multiple
                      :options="rolesList"
                      label="name"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Avatar</label>
                  <div class="col-md-10">
                    <image-uploader @changeFile="avatarUploaded" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            User has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from 'vue-select';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';

export default {
  name: 'UserNew',

  components: {
    'vue-select': VueSelect,
  },

  mixins: [CreatePageMixin],

  data() {
    return {
      entity: {
        name: null,
        email: null,
        password: null,
        password_confirmation: null,
        roles: [],
        avatar: null,
      },
    };
  },

  computed: {
    rolesList() {
      return this.$store.state.roles.list;
    },
  },

  methods: {
    isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Name field is required');
        return false;
      }
      if (!this.entity.email) {
        this.$_showError('Email field is required');
        return false;
      }
      if (!this.entity.password) {
        this.$_showError('Password field is required');
        return false;
      }
      if (this.entity.password.length < 6) {
        this.$_showError('The password must be at least 6 characters');
        return false;
      }
      if (this.entity.password !== this.entity.password_confirmation) {
        this.$_showError('Password confirmation is wrong');
        return false;
      }
      if (!this.entity.roles.length) {
        this.$_showError('Roles field is required');
        return false;
      }
      return true;
    },
    avatarUploaded(file) {
      this.entity.avatar = file;
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      postFormData.append('email', this.entity.email);
      postFormData.append('password', this.entity.password);
      postFormData.append('password_confirmation', this.entity.password_confirmation);
      if (this.entity.roles && this.entity.roles.length) {
        for (let i = 0; i < this.entity.roles.length; i += 1) {
          postFormData.append('roles[]', this.entity.roles[i].id);
        }
      }
      if (this.entity.avatar) postFormData.append('avatar', this.entity.avatar);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}users`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest()
        .then((response) => {
          this.$_successSave();
          this.$parent.getSource();
          window.location.hash = `#/admin/users/edit/${response.data.id}`;
        }).catch((error) => {
          console.error('Error in user create query', error);
          this.$_errorSave(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?5458246a